"use client";

import { createContext } from "react";
import type { AppUser } from "@huub-web/backend";

export type AdvisorBookingContextState = {
  /**
   * The authenticated user's display info (name, email)
   */
  user: AppUser;
  /**
   * The Calendly booking URL (with fallback applied by AppScreen)
   */
  url: string;
};

export const AdvisorBookingContext =
  createContext<AdvisorBookingContextState | null>(null);
